import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GuestMember = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const memberToken = localStorage.getItem("memberAccessToken");
        const isOnboarding = localStorage.getItem("isOnboarding") === "true";
        console.log("isOnboarding ", !isOnboarding)
        if (memberToken && !isOnboarding) {
            navigate("/member/dashboard", { replace: true });
        }
    }, [navigate]);

    return <>{children}</>;
};

export default GuestMember;